import { Alert, Flex } from "antd";
import { plural } from "utils";

type Props = {
  days: number;
  isOperator: boolean;
};

export const BidCloseAlert = ({ days, isOperator }: Props) => {
  return (
    <Flex>
      <Alert
        message={`Заявка не завершена в течение ${days} ${plural(days, [
          "дня",
          "дней",
          "дней",
        ])}, ${isOperator ? "у вас есть возможность принудительно завершить обмен валюты за УВЭД" : "требуется продать криптовалюту не позднее 90 дней"}`}
        type="warning"
        showIcon
      />
    </Flex>
  );
};
